// API service for making requests to the backend

// Always use the full URL to avoid proxy issues
// Use IP address instead of localhost to avoid potential IPv6 issues
// Server is running on port 3000
const API_URL = 'http://127.0.0.1:3000/api';

// Quotes API
export const fetchQuotes = async () => {
  try {
    console.log('Making API request to:', `${API_URL}/quotes`);

    const response = await fetch(`${API_URL}/quotes`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      // Add cache busting parameter
      cache: 'no-cache',
    });

    console.log('Response status:', response.status);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Parsed response data, quotes count:', data.length);
    return data;
  } catch (error) {
    console.error('Error fetching quotes:', error);
    throw error;
  }
};

export const fetchQuoteById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/quotes/${id}`);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Error fetching quote with id ${id}:`, error);
    throw error;
  }
};

export const createQuote = async (quoteData) => {
  try {
    const response = await fetch(`${API_URL}/quotes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(quoteData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error creating quote:', error);
    throw error;
  }
};

export const updateQuote = async (id, quoteData) => {
  try {
    const response = await fetch(`${API_URL}/quotes/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(quoteData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Error updating quote with id ${id}:`, error);
    throw error;
  }
};

export const deleteQuote = async (id) => {
  try {
    const response = await fetch(`${API_URL}/quotes/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Error deleting quote with id ${id}:`, error);
    throw error;
  }
};

// Favorites API
export const addToFavorites = async (userId, quoteId) => {
  try {
    const response = await fetch(`${API_URL}/users/${userId}/favorites`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ quoteId }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error adding to favorites:', error);
    throw error;
  }
};
